import React from 'react'
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import NewTicket from './NewTicket';

const NewTicketMenu = () => {
  return (
 <>
      <Header />
      <NewTicket/>
      <Footer />
    </>  )
}

export default NewTicketMenu